import { useStripes } from '@folio/stripes/core';
export var useIsEscEnvCheck = function () {
    var _a, _b;
    var stripes = useStripes();
    return {
        // @ts-ignore
        isESC: Boolean((_b = (_a = stripes === null || stripes === void 0 ? void 0 : stripes.user) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.consortium)
    };
};
